import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getProjects, updateMetadataProjectFail } from 'store/actions';

const initialState = {
    projects: {},
    activeProject: null,
    order: [],
    error: null,
    loading: false,
    deletedLoading: false
};

const getProjectsStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getProjectsFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const getProjectsSuccess = (state, action) => {
    let newProjects = {},
        members,
        project;
    Object.keys(action.projects).forEach(id => {
        members = [];
        project = action.projects[id];
        const { metadata, clips, ...pData } = project.data;

        project.members.forEach((member) => {
            members.push(project.membermetadata.members[member].email);
        });
        metadata.fields.members = members.join(';');

        newProjects[project.id] = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project, created: metadata.fields.created };

    });

    return updateObject(state, {
        projects: newProjects, loading: false
    });
}

const getDeletedProjectsStart = (state, action) => {
    return updateObject(state, { error: null, deletedLoading: true });
}

const getDeletedProjectsSuccess = (state, action) => {
    let newProjects = {};
    Object.keys(action.deletedProjects).forEach(id => {
        let project = action.deletedProjects[id];
        const { metadata, clips, ...pData } = project.data;
        newProjects[project.id] = { ...pData, metadata: metadata, originalObject: project, created: metadata.fields.created };

    });

    return updateObject(state, {
        deletedProjects: newProjects, deletedLoading: false
    });
}

const projectDeleted = (state, action) => {
    let newProjects = { ...state.projects };
    delete (newProjects[action.payload.projectId]);
    return updateObject(state, { projects: newProjects });
}

const saveNewProject = (state, action) => {
    let maxProjectId = 0;
    for (let project of state) {
        if (project.projectId > maxProjectId) {
            maxProjectId = project.projectId;
            console.log("maxProjectId:" + maxProjectId);
        }
    }
    return state;
}

const setActiveProject = (state, action) => {
    return updateObject(state, { activeProject: action.payload.activeProject });
}

const updateProject = (state, action) => {
    console.log("updating project");
    let members = [];
    let project = action.project;
    const { metadata, clips, ...pData } = project.data;

    project.members.forEach((member) => {
        members.push(project.membermetadata.members[member].email);
    });
    metadata.fields.members = members.join(';');

    let newProject = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project };

    return updateObject(state, { projects: updateObject(state.projects, { [project.id]: newProject }) });
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PROJECTS_START: return getProjectsStart(state, action);
        case actionTypes.GET_PROJECTS_SUCCESS: return getProjectsSuccess(state, action);
        case actionTypes.GET_PROJECTS_FAIL: return getProjectsFail(state, action);

        case actionTypes.GET_DELETED_PROJECTS_SUCCESS: return getDeletedProjectsSuccess(state, action);
        case actionTypes.GET_DELETED_PROJECTS_START: return getDeletedProjectsStart(state, action);
        case actionTypes.DELETE_PROJECT_SUCCESS: return projectDeleted(state, action);

        case actionTypes.SAVE_NEW_PROJECT: return saveNewProject(state, action);
        case actionTypes.SET_ACTIVE_PROJECT: return setActiveProject(state, action);
        case actionTypes.PROJECT_UPDATE_RECEIVED: return updateProject(state, action);
        default:
            return state;
    }
}

export default reducer;
